import React, { useEffect, useState, useMemo } from "react";
import { connect } from "react-redux";
// import { Actions as LEAVEACTIONS } from '../../store/actions/leaveActions';
// import { Actions as EMPLOYEEACTIONS } from '../../store/actions/employeeActions';

import AuditLogRow from "./AuditLogRow";
import { format, addMonths } from "date-fns";

const AuditLogs = ({ auditLogs, nextToken, getMoreLogs }) => {
	return (
		<React.Fragment>
			<div className="table-responsive">
				<div
					id="active-people-table_wrapper"
					className="dataTables_wrapper no-footer"
				>
					<table
						id="active-people-table"
						className="js-table-sections table table-hover"
					>
						<thead style={{ display: "table-header-group" }}>
							<tr>
								<th></th>
								<th>ACTION</th>
								<th>TYPE</th>
								<th>DATE</th>
								<th></th>
							</tr>
						</thead>
						<tbody>
							{auditLogs ? (
								auditLogs.map((logEntry) => (
									<AuditLogRow
										key={logEntry.id}
										logEntry={logEntry}
									/>
								))
							) : (
								<tr>
									<td colSpan="6"> Loading Audit Logs, hold on...</td>
								</tr>
							)}
							{nextToken && (
								<tr>
									<td colSpan="6">
										<span onClick={getMoreLogs}>View More Logs</span>
									</td>
								</tr>
							)}
						</tbody>
					</table>
				</div>
			</div>
		</React.Fragment>
	);
};

const mapStateToProps = (state) => {
	return {
		auditLogs: state?.pensions?.auditLogs,
	};
};

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(AuditLogs);
